import React, { useEffect, useRef, useState } from "react";
import Header from "layout/dictionarySearch/document/categories/Header";
import InfiniteGrid from "components/Grid";
import Category from "layout/dictionarySearch/Category";
import Item from "layout/dictionarySearch/Item";
import { useSelector } from "react-redux";
import { hoverSame, unhoverSame } from "utils";

const Categories = () => {
  const categoriesRef = useRef(undefined);
  const outerListRef = useRef(undefined);
  const innerListRef = useRef(undefined);
  const [rows, setRows] = useState([]);
  const document = useSelector((state) => state.dictionarySearch.documents[0]);
  const dictionary = useSelector(
    (state) => state.dictionarySearch.documents[0].dictionary
  );
  const categories = useSelector(
    (state) => state.dictionarySearch.documents[0].dictionary.categories
  );

  // using Array.reduce method to avoid stack overflow exceptions when using Math library on large arrays
  const maxOccurrences = categories?.reduce(
    (max, current) => Math.max(max, current.occurrences),
    0
  );

  useEffect(() => {
    const result = [];
    categories.forEach((category) => {
      result.push(
        <Category
          category={category}
          maxOccurrences={maxOccurrences}
          docId={document.id}
          alignCollapseButtonToRight
        />
      );
      if (category.expanded) {
        category.items?.forEach((item) => {
          result.push(
            <Item
              item={item}
              maxOccurrences={maxOccurrences}
              docId={document.id}
            />
          );
        });
      }
    });
    setRows(result);
  }, [categories]);

  const renderRow = ({ rowIndex, style }) => {
    return (
      <div
        style={style}
        className={`item item-${rowIndex}`}
        onMouseOver={() => hoverSame(rowIndex)}
        onFocus={() => hoverSame(rowIndex)}
        onMouseOut={unhoverSame}
        onBlur={unhoverSame}
      >
        {rows[rowIndex]}
      </div>
    );
  };

  return (
    <div className="categories" data-testid="categories-pane">
      <Header
        dictionary={dictionary}
        categoryCount={categories.length}
        docId={document.id}
      />
      <div className="categories__body">
        <InfiniteGrid
          listRef={categoriesRef}
          rowSize={26}
          outerRef={outerListRef}
          innerRef={innerListRef}
          rowCount={rows.length}
          renderRow={renderRow}
          columnCount={1}
        />
      </div>
    </div>
  );
};

export default Categories;
